import { convertSearchObjectToBase64 } from 'utils/objToBase64'

export const getCipherHeader = () => {
  const CryptoJS = require("crypto-js");
  const Ciphertext = CryptoJS.AES.encrypt(convertSearchObjectToBase64({
    'system': 'project-ark'
  }), 'wH_u%%P5~Sl?:J5A0e^~"4sCmgn@lD>*').toString()
  return Ciphertext
}